import React, { useEffect } from 'react';

interface UploadDisabledModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
}

const UploadDisabledModal: React.FC<UploadDisabledModalProps> = ({ isOpen, onClose, message }) => {
  useEffect(() => {
    if (isOpen) {
      const handleClick = () => onClose();
      // Small delay to prevent immediate dismissal from the same click
      setTimeout(() => {
        document.addEventListener('click', handleClick);
      }, 100);
      return () => document.removeEventListener('click', handleClick);
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div 
      style={{ 
        position: 'absolute',
        backgroundColor: 'var(--surface)',
        color: 'var(--text-primary)',
        padding: '12px 16px',
        borderRadius: '6px',
        fontSize: '14px',
        marginTop: '8px',
        textAlign: 'center',
        maxWidth: '280px',
        zIndex: 1000,
        border: '2px dashed #6b7280'
      }}
    >
      {message || "Sessions cannot be uploaded at this time. We are releasing this feature to the public shortly."}
    </div>
  );
};

export default UploadDisabledModal;
